import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';

interface NoDataWithCheckProps {
    title: string;
    subtitle?: string;
    extraSubtitle?: string;
    declareNoDataText: string;
    checkState: boolean;
    onClickCheck: any;
}

const NoDataWithCheck = ({
    title,
    subtitle,
    extraSubtitle,
    declareNoDataText,
    checkState,
    onClickCheck
}: NoDataWithCheckProps) => {
    return (
        <Grid
            // Antes pt/pb de 112 px: con el pie fijo del informe, el texto de
            // abajo quedaba cortado y arriba sobraba un hueco grande.
            pt={5}
            pb={6}
            container
            xs
            textAlign={'center'}
            justifyContent={'center'}
            alignItems={'center'}
            direction={'column'}
            gap={1}
        >
            <Typography variant="subtitle1" fontSize={'20px'} maxWidth={'60%'}>
                {title}
            </Typography>
            <Typography fontSize={16} color={'#384A52'} variant="h4" mt={0} pt={0} maxWidth={'580px'}>
                {subtitle}
            </Typography>
            <Typography fontSize={16} color={'#384A52'} variant="h4" mt={0} pt={0}>
                {extraSubtitle}
            </Typography>

            {/* FormControlLabel: el texto queda asociado al checkbox (se puede
                clickear y lo anuncian los lectores de pantalla). */}
            <FormControlLabel
                sx={{ mt: 1, mr: 0 }}
                control={
                    <Checkbox
                        inputProps={
                            {
                                'data-testid': 'noDataCheckbox'
                            } as React.InputHTMLAttributes<HTMLInputElement>
                        }
                        checked={checkState}
                        onChange={onClickCheck}
                    />
                }
                label={
                    <Typography fontSize={16} color={'#384A52'} component="span">
                        {declareNoDataText}
                    </Typography>
                }
            />
        </Grid>
    );
};

export { NoDataWithCheck };
